module.exports = __webpack_public_path__ + "static/king-lear-d6701fe4a918d4dd92a34711022dcc54.jpg";